export default [
	{
		path: '/selectoption/list/:type',
		name: 'SelectOptionList',
		component: () => import('../views/admin/selectoption/list-view.vue'),
		meta: {
			title_key: 'router.selectOptionList',
		},
	},
	{
		path: '/selectoption/form/:type/:id?',
		name: 'SelectOptionForm',
		component: () => import('../views/admin/selectoption/form-view.vue'),
		meta: {
			title_key: 'router.selectOptionForm',
		},
	},
	{
		path: '/species/list',
		name: 'SpeciesList',
		component: () => import('../views/admin/species/list-view.vue'),
		meta: {
			title_key: 'router.speciesList',
		},
	},
	{
		path: '/species/list-export',
		name: 'SpeciesExport',
		component: () => import('../views/admin/species/export-view.vue'),
		meta: {
			title_key: 'router.speciesExport',
		},
	},
	{
		path: '/species/form/:id?',
		name: 'SpeciesForm',
		component: () => import('../views/admin/species/form-view.vue'),
		meta: {
			title_key: 'router.speciesForm',
		},
	},
	{
		path: '/species/view/:id?',
		name: 'SpeciesDisplay',
		component: () => import('../views/admin/species/detail-view.vue'),
		meta: {
			title_key: 'router.speciesDisplay',
		},
	},
	{
		path: '/offergroup/list',
		name: 'OffergroupList',
		component: () => import('../views/admin/offergroup/list-view.vue'),
		meta: {
			title_key: 'router.offergroupList',
		},
	},
	{
		path: '/offergroup/form/:id?',
		name: 'OffergroupForm',
		component: () => import('../views/admin/offergroup/form-view.vue'),
		meta: {
			title_key: 'router.offergroupForm',
		},
	},
	{
		path: '/offergroup/import',
		name: 'OffergroupImportExport',
		component: () => import('../views/admin/offergroup/import-export-view.vue'),
		meta: {
			title_key: 'router.offergroupImportExport',
		},
	},
	{
		path: '/offerfield/list',
		name: 'OfferfieldList',
		component: () => import('../views/admin/offerfield/list-view.vue'),
		meta: {
			title_key: 'router.offerfieldList',
		},
	},
	{
		path: '/offerfield/form/:id?',
		name: 'OfferfieldForm',
		component: () => import('../views/admin/offerfield/form-view.vue'),
		meta: {
			title_key: 'router.offerfieldForm',
		},
	},
	{
		path: '/sort/list',
		name: 'SortList',
		component: () => import('../views/sort/list-view.vue'),
		meta: {
			title_key: 'router.sortList',
		},
	},
	{
		path: '/sort/form/:id?',
		name: 'SortForm',
		component: () => import('../views/sort/form-view.vue'),
		meta: {
			title_key: 'router.sortForm',
		},
	},
	{
		path: '/seedFlags/list',
		name: 'SeedFlagsList',
		component: () => import('../views/admin/seedflag/list-view.vue'),
		meta: {
			title_key: 'router.seedFlagsList',
		},
	},
	{
		path: '/seedFlags/form/:id?',
		name: 'SeedFlagsForm',
		component: () => import('../views/admin/seedflag/form-view.vue'),
		meta: {
			title_key: 'router.seedFlagsForm',
		},
	},
	{
		path: '/menu/list',
		name: 'MenuList',
		component: () => import('../views/admin/menu/list-view.vue'),
		meta: {
			title_key: 'router.menuList',
		},
	},
	{
		path: '/uploads/list',
		name: 'UploadList',
		component: () => import('../views/admin/uploads/list-view.vue'),
		meta: {
			title_key: 'components.menu.docsManagement',
		},
	},
	{
		path: '/menu/form/:id?',
		name: 'MenuForm',
		component: () => import('../views/admin/menu/form-view.vue'),
		meta: {
			title_key: 'router.menuForm',
		},
	},
	{
		path: '/user/list',
		name: 'UserList',
		component: () => import('../views/admin/user/list-view.vue'),
		meta: {
			title_key: 'router.userList',
		},
	},
	{
		path: '/user/form/:type/:id?',
		name: 'UserForm',
		component: () => import('../views/admin/user/form-view.vue'),
		meta: {
			title_key: 'router.userForm',
		},
	},
	{
		path: '/user/import',
		name: 'UserImport',
		component: () => import('../views/admin/user/import-view.vue'),
		meta: {
			title_key: 'router.userImport',
		},
	},
	{
		path: '/user/export',
		name: 'UserExport',
		component: () => import('../views/admin/user/export-view.vue'),
		meta: {
			title_key: 'router.userExport',
		},
	},
	{
		path: '/user/accept-invite',
		name: 'AcceptInvite',
		component: () => import('../views/user/invite.vue'),
		meta: {
			title_key: 'router.userInvite',
		},
	},
	{
		path: '/config/country',
		name: 'CountryConfig',
		component: () => import('../views/admin/config/country-view.vue'),
		meta: {
			title_key: 'router.countryConfig',
		},
	},
	{
		path: '/bbay/classification',
		name: 'BbayClassification',
		component: () => import('../views/admin/bbay/classification-view.vue'),
		meta: {
			title_key: 'router.bbayClassification',
		},
	},
	{
		path: '/bbay/units',
		name: 'BbayUnits',
		component: () => import('../views/admin/bbay/units-view.vue'),
		meta: {
			title_key: 'router.bbayUnits',
		},
	},
	{
		path: '/request/pkg/:id?',
		name: 'RequestPkgManagement',
		component: () => import('../views/admin/request/request-pkg-view.vue'),
		meta: {
			title_key: 'router.requestPkg',
		},
	},
	{
		path: '/request/delete',
		name: 'RequestDeleteManagement',
		component: () => import('../views/admin/request/request-delete-view.vue'),
		meta: {
			title_key: 'router.requestPkgDelete',
		},
	},
	{
		path: '/request/export/attachment',
		name: 'RequestExportAttachments',
		component: () => import('../views/admin/request/export-attachments-view.vue'),
		meta: {
			title_key: 'router.requestPkgDelete',
		},
	},
	{
		path: '/messagecenter/list',
		name: 'MessageCenter',
		component: () => import('../views/message/center-view.vue'),
		meta: {
			title_key: 'router.messageCenter',
		},
		children: [
			{
				path: 'detail/:id',
				name: 'MessageDetail',
				component: () => import('../views/message/conversation-view.vue'),
				meta: {
					title_key: 'router.messageDetail',
				},
			},
		],
	},
	{
		path: '/cms/list',
		name: 'CmsOverview',
		component: () => import('../views/cms/overview-view.vue'),
		meta: {
			title_key: 'router.cmsOverview',
		},
	},
	{
		path: '/cms/form/:id',
		name: 'CmsEdit',
		component: () => import('../views/cms/edit-view.vue'),
		meta: {
			title_key: 'router.cmsEdit',
		},
	},
	{
		path: '/cms/page/:id',
		name: 'CmsPage',
		component: () => import('../views/cms/page-view.vue'),
		meta: {
			title_key: 'router.cmsPage',
		},
	},
	{
		path: '/offer/list',
		name: 'OfferList',
		component: () => import('../views/offer/list-view.vue'),
		meta: {
			title_key: 'router.offerList',
		},
	},
	{
		path: '/offer/form/:id?',
		name: 'OfferForm',
		component: () => import('../views/offer/form-view.vue'),
		meta: {
			title_key: 'router.offerForm',
		},
	},
	{
		path: '/offergroup/country-export',
		name: 'OffergroupCountryExport',
		component: () => import('../views/admin/offergroup/country-export.vue'),
		meta: {
			title_key: 'router.offergroupCountryExport',
		},
	},
	{
		path: '/aut/offer_export',
		name: 'AutOfferExport',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'router.autOfferExport',
		},
	},
	{
		path: '/offer/mix-report',
		name: 'OfferMixReportExport',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'router.offerMixReportExport',
		},
	},
	{
		path: '/offer/prm-report',
		name: 'OfferPrmReportExport',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'router.offerPrmReportExport',
		},
	},
	{
		path: '/offer/inactive-offergroup-export',
		name: 'OfferInactiveOffergroupExport',
		component: () => import('../views/offer/offer-export-view.vue'),
		meta: {
			title_key: 'router.offerInactiveOffergroupExport',
		},
	},
	{
		path: '/agr/detail-export',
		name: 'AgrDetailExport',
		component: () => import('../views/user/agr-detail-export.vue'),
		meta: {
			title_key: 'components.menu.agrExport',
		},
	},
	{
		path: '/request/report',
		name: 'RequestReport',
		component: () => import('../views/request/kom-report-view.vue'),
		meta: {
			title_key: 'components.menu.requestReport',
		},
	},
	{
		path: '/offer/changes',
		name: 'OfferChangesList',
		component: () => import('../views/offer/changes-view.vue'),
		meta: {
			title_key: 'components.menu.offerChanges',
		},
	},
	{
		path: '/cms/mail-list',
		name: 'CmsMailList',
		component: () => import('../views/cms/mail-list.vue'),
		meta: {
			title: 'Mail Templates',
		},
	},
	{
		path: '/cms/mail/edit/:tpl/:lang',
		name: 'CmsMailTemplateEdit',
		component: () => import('../views/cms/mail-edit.vue'),
		meta: {
			title: 'Mail Template Edit',
		},
	},
	{
		path: '/oxs/agb',
		name: 'AgbDescription',
		component: () => import('../views/cms/agb-view.vue'),
		meta: {
			title_key: 'router.agbDescription',
		},
	},
	{
		path: '/adm/profile',
		name: 'AdminProfile',
		component: () => import('../views/user/adm-profile-view.vue'),
		meta: {
			title_key: ('router.userProfile'),
		},
	},
];
